const PORTAL_BUTTON_SELECTOR = 'a[data-set-single_portal_name]';

class PortalButtonTracker {
  constructor() {
    this.listenerAttached = false;
    this.handlePortalClick = this.handlePortalClick.bind(this);
  }

  getButtonType(button) {
    const classList = (button.className || '').toLowerCase();
    if (classList.includes('account-top-link')) {
      return 'login';
    }
    if (classList.includes('android')) {
      return 'android';
    }
    if (classList.includes('ios')) {
      return 'ios';
    }
    return 'login';
  }

  getButtonName(button, type) {
    const text = (button.textContent || '').trim();
    if (type === 'login') {
      return text || 'Login';
    }
    if (type === 'android') {
      return 'Android App';
    }
    if (type === 'ios') {
      return 'iOS App';
    }
    return 'portal button';
  }

  buildPayload(button) {
    const now = new Date();
    const buttonType = this.getButtonType(button);
    return {
      panel_name: button.getAttribute('data-set-single_portal_name') || '',
      button_type: buttonType,
      button_name: this.getButtonName(button, buttonType),
      date: now.toLocaleDateString(),
      time: now.toLocaleTimeString('en-US', { timeZone: 'America/New_York' }),
      day_of_week: now.toLocaleDateString('en-US', { weekday: 'long' }),
      page_url: window.location.href,
    };
  }

  openInTab(button) {
    const url = button.getAttribute('href');
    if (!url) {
      return;
    }

    const target = button.getAttribute('target') || '_blank';
    const newWindow = window.open(url, target);

    const relAttr = button.getAttribute('rel');
    if (newWindow && relAttr && relAttr.includes('noopener')) {
      newWindow.opener = null;
    }
  }

  handlePortalClick(event) {
    if (event.defaultPrevented) {
      return;
    }

    let target = event.target;
    if (target && target.nodeType !== Node.ELEMENT_NODE) {
      target = target.parentElement;
    }

    const button = target?.closest(PORTAL_BUTTON_SELECTOR);
    if (!button) {
      return;
    }

    event.preventDefault();

    const payload = this.buildPayload(button);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'portal_button_click',
      ...payload,
    });

    this.openInTab(button);
  }

  init() {
    if (typeof document === 'undefined' || this.listenerAttached) {
      return;
    }

    this.listenerAttached = true;
    document.addEventListener('click', this.handlePortalClick);
  }
}

const portalButtonTracker = new PortalButtonTracker();

export const initPortalButtonTracking = () => portalButtonTracker.init();

export default portalButtonTracker;
